import React from 'react';
import cx from 'classnames';
import * as styles from './ContactsPlaceholder.scss';

const ContactsPlaceholder = ({ className, isMobile } = {}) => (
  <div className={cx(styles.contactsPlaceholder, styles[className], { [styles.mobile]: isMobile })}>
    <p className={styles.placeholderTitle} />
    <p className={styles.placeholderRow} />
    <p className={styles.placeholderRow} />
    { isMobile ? <p className={styles.placeholderRow} /> : null }
  </div>
);

export default ContactsPlaceholder;
